// exports
export default {
  MAP_BUCKET_URL: `${process.env.REACT_APP_NFT_BUCKET_BASE_URL || ''}/map`,
  MAP_PINS_BUCKET_URL: `${process.env.REACT_APP_NFT_BUCKET_BASE_URL || ''}/mappins`,
  BACKPACK_BUCKET_URL: `${process.env.REACT_APP_NFT_BUCKET_BASE_URL || ''}/backpackitems`,
  SKYBORNE: 'https://skybornegenesis.com',
  GIT_BOOK: 'https://info.skybornegenesis.com',
  TOS: 'https://info.skybornegenesis.com/important/terms-of-use',
  PRIVACY_POLICY: 'https://info.skybornegenesis.com/important/privacy-policy',
  OPEN_SEA_COLLECTION_IMMORTALS: 'https://opensea.io/assets/ethereum/0x963590fabdc1333d03bc3af42a6b2ab33e21e2ee',
  OPEN_SEA_COLLECTION_LOOT: 'https://opensea.io/assets/arbitrum-nova/0xf31e12938b9957348519318ae07be99a21cc2255',
  REVOLVING_GAMES: 'https://revolvinggames.com',
  INSTAGRAM: 'https://www.instagram.com/skybornelegacy',
  TWITTER: 'https://twitter.com/SkyborneLegacy',
  FACEBOOK: 'https://www.facebook.com/Skyborne-Legacy-100146679546554',
  DISCORD: 'https://discord.gg/skybornelegacy',
  YOUTUBE: 'https://www.youtube.com/@SkyborneLegacy',
  TWITCH: 'https://www.twitch.tv/skybornelegacy',
  TIK_TOK: 'https://www.tiktok.com/@skybornelegacy',
  MEDIUM: 'https://medium.com/@SkyborneLegacy'
} as const;
